// 产品状态
export const aclOrderStatusMap = {
  'REFUND': '已退款',
  'NOTEFFECT': '未生效',
  'NOTUSED': '未使用',
  'USED': '已使用',
  'OVERDUE': '已过期',
  'EFFECT': '已生效',
  'CANCELED': '已取消',
  'REFUNDED': '已退订'
}

// 产品类型
export const productTypeMap = {
  'VIPHALL': '贵宾厅',
  'MEAL': '餐食',
  'LUGGAGE': '预付费行李',
  'BUYSEAT': '付费选座',
  'SEAT': '预选座位',
  'BOARDING': '登机牌',
  'PAYCHARGE': '支付手续费',
  'COMSER': '短信',
  'ITINERARY': '行程单',
  'ITINERARY_YD': '行程单',
  'TRANSFER': '接送机',
  'INSURANCE': '保险',
  'UPGRADE': '升舱'
}

// 子单状态
export const aclSubOrderStatusMap = {
  // UNI枚举
  'WP': '等待付款',
  'XX': '已取消',
  'HP': '支付未出票',
  'SB': '出票失败',
  'PF': '已付款',
  'RH': '退订中',
  'RF': '已退订',
  'RB': '退订失败'
}
